import { Mail, MapPin, Clock, CalendarCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { JANE_BOOKING_URL } from '../data/janeServices';

const ContactPage = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      value: 'margaret@baysidehealth-flkeys.com',
      href: 'mailto:margaret@baysidehealth-flkeys.com',
      description: 'For general questions'
    },
    {
      icon: MapPin,
      title: 'Location',
      value: 'The Turek Building',
      href: 'https://maps.google.com/?q=90290+Overseas+Hwy+Suite+106+Tavernier+FL+33070',
      description: '90290 Overseas Hwy, Suite 106, Tavernier, FL 33070'
    }
  ];

  return (
    <div data-testid="contact-page" className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-24 md:py-32 bg-muted">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center max-w-3xl mx-auto space-y-6">
            <p className="text-sm tracking-widest uppercase font-semibold text-primary">
              Get in Touch
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-foreground">
              Let's Start Your Journey Together
            </h1>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Appointments are booked online. For anything else, here is how to reach me.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 -mt-8">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {contactInfo.map((info) => (
              <div
                key={info.title}
                data-testid={`contact-info-${info.title.toLowerCase()}`}
                className="bg-white p-8 rounded-3xl shadow-lg border border-border/50 text-center"
              >
                <div className="w-16 h-16 bg-secondary/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <info.icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-medium text-foreground mb-2">
                  {info.title}
                </h3>
                <a
                  href={info.href}
                  target={info.href.startsWith('http') ? '_blank' : undefined}
                  rel={info.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  data-testid={`contact-link-${info.title.toLowerCase()}`}
                  className="text-lg text-primary hover:underline block mb-2 break-words"
                >
                  {info.value}
                </a>
                <p className="text-sm text-muted-foreground">
                  {info.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Office Hours */}
      <section data-testid="office-hours-section" className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="bg-white rounded-3xl shadow-xl border border-border/50 p-10 md:p-14 text-center space-y-6">
            <div className="w-16 h-16 bg-secondary/20 rounded-2xl flex items-center justify-center mx-auto">
              <Clock className="w-8 h-8 text-primary" strokeWidth={1.5} />
            </div>
            <h2 className="text-3xl md:text-4xl font-medium text-foreground">
              Visiting the Office
            </h2>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Bayside Birth &amp; Pelvic Health is located in The Turek Building in
              Tavernier. At-home lactation visits can be arranged on request.
            </p>
            <div className="pt-2">
              <a
                href={JANE_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-book-online-button"
              >
                <Button className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 rounded-full text-base font-medium transition-transform hover:-translate-y-1">
                  <CalendarCheck className="w-5 h-5 mr-2" />
                  Book Online
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
